import { HttpResponse, httpService } from '../core/http'

const STORAGETOKEN = '@SYGO-CRM-USER'

export interface AuthLogin {
  username: string
  password: string
}

export const isAuthenticated = () => {
  const token = localStorage.getItem(STORAGETOKEN)
  if (token) {
    const tokenParsed = JSON.parse(token)
    if (!tokenParsed.accessToken) return false
    if (!tokenParsed.active) return false
    if (!tokenParsed.company) return false
    if (!tokenParsed.email) return false
    if (!tokenParsed.id) return false
    if (!tokenParsed.role) return false
    if (!tokenParsed.username) return false
    return true
  }
  return false
}

export const login = async (authLogin: AuthLogin): Promise<any> => {
  console.log('teste')
  try {
    const httpResponse: HttpResponse = await httpService.post(
      '/auth/login',
      authLogin
    )
    return httpResponse.data
  } catch (error) {
    return error
  }
}
